export const isRequired = () => {
  return typeof d !== 'undefined';
};



// WEBPACK FOOTER //
// ./src/helpers/validators.js